import ContainerDimensions from './ContainerDimensions';

export default ContainerDimensions;
